export default "/images/00a0d71902c5c67bf9bd78ff5aaa0502.jpg";